import './styles.scss';

export const Carousel = ({children}: any) => {
    return <div className='wrapper'>
        {children}
    </div>
}